import { PostPushNotification, TargetGroupEnum } from 'ck-queries';

import dayjs from 'dayjs';

const scheduleTimeDefault = dayjs().add(1, 'hour').format('YYYY-MM-DD hh:mm');
export const defaultPushNotificationValues: PostPushNotification = {
  inboxMessageEnglish: '',
  inboxMessageSwedish: '',
  titleEnglish: '',
  titleSwedish: '',
  notificationMessageEnglish: '',
  notificationMessageSwedish: '',
  scheduleTime: scheduleTimeDefault,
  isDraft: false,
  targetGroup: {
    group: 'All' as TargetGroupEnum,
    count: 0,
    divisionName: '',
  },
  createdByDivisionName: '',
};
